import { FC, useContext, useEffect, useState } from "react";
import { AiOutlineLoading } from "react-icons/ai";
import MEditor, { Monaco } from "@monaco-editor/react";
import { Screen } from "./helpers/Screen";
import { FileSystem } from "./helpers/FileSystem";
import { Communication } from "../../contexts/communicationContext";
import { Auth } from "../../contexts/ridersUserContext";
import {setArduinoLanguage, setPythonEditorTheme} from "../../components/vs-code/Arduino/Utils";

const LoadingScreen: FC = () => {
  return (
    <div style={{ color: "white" }}>
      <AiOutlineLoading
        style={{ width: "60px", height: "60px", color: "white" }}
      />
      <p>Editor is loading</p>
    </div>
  );
};

export const Editor: FC<{
  file_path: string;
  code: string | undefined;
  setCode: Function;
  setMount: Function;
  className: string;
  editorClassName?: string;
  readonly?: boolean;
}> = (props) => {
  const { file_path, setCode, setMount, className, editorClassName } = props;

  const { refreshKey } = useContext<any>(Screen.context);
  const { readFile } = useContext<any>(FileSystem.context);

  const { setFilePath } = useContext<any>(Communication.context);
  const { projectType, language } = useContext<any>(Auth.context);

  const isDark = document
    .getElementsByTagName("body")[0]
    .classList.contains("dark");

  const [userCode, setUserCode] = useState<string | undefined>(undefined);

  const editorBeforeMount = (monaco: Monaco) => {
    setArduinoLanguage(monaco);
  };

  useEffect(() => {
    if (file_path) {
      readFile(file_path).then((code: string) => {
        setUserCode(code);

        if (code) {
          setFilePath(file_path);
        } else {
          setFilePath("/usercode/user_code.py");
        }
      });
    }
  }, [file_path, refreshKey]);

  return (
    <div className={className}>
      {language && (
        <MEditor
          key={refreshKey}
          defaultLanguage={
            ["cpp", "ino"].includes(language) ? "arduino" : language
          }
          language={["cpp", "ino"].includes(language) ? "arduino" : language}
          value={userCode}
          theme={isDark && language === "python" ? "riders-vs-dark" : isDark && ["cpp", "ino"].includes(language) ? "dark-arduino-theme" : "arduino-theme"}
          onChange={(value, event) => setCode(value)}
          onMount={(editor, monaco) => setMount(editor)}
          beforeMount={
            ["cpp", "ino"].includes(language)
              ? (monaco: Monaco) => editorBeforeMount(monaco)
              : language === "python" ? (monaco: Monaco) => setPythonEditorTheme(monaco) : undefined
          }
          className={editorClassName}
          loading={<LoadingScreen />}
          options={{
            readOnly: props.readonly,
          }}
        />
      )}
    </div>
  );
};
